/*
 * PinkSalt reviews (Judge.me, free) — naloraco-style list rendered from Judge.me's
 * own reviews API, loaded from layout/theme.liquid on product pages.
 *
 * Why: the Judge.me metafield widget renders a static HTML snapshot that the v3
 * app-embed JS cannot paginate (clicking a page fires the API but never re-renders),
 * and its API ignores sort params + caps per_page at 30. So we keep Judge.me's
 * summary + histogram + "Write a review" + AggregateRating JSON-LD (SEO), HIDE its
 * static cards + broken numbered pager + native sort row, and render our OWN bordered
 * rose cards: we fetch ALL reviews (5 pages of 30) once, then sort + paginate them
 * CLIENT-SIDE (so the sort dropdown actually works and "Load more" is instant).
 *
 * Placement fix: the injected list + Load-more go in as BLOCK children of
 * .jdgm-rev-widg (after its header), NOT inside .jdgm-row-stars, which Judge.me
 * lays out as display:flex; align-items:stretch — a tall list child there stretches
 * the summary/histogram/button into mangled columns.
 *
 * Data reality: the imported reviews carry NO country (0 flags) and very few photos,
 * so most cards have no photo. That is a data limit, not styling. Never fabricated.
 *
 * No-ops on pages without #ps-reviews (e.g. the lamps, until their reviews import).
 */
(function () {
  var root = document.querySelector('#ps-reviews');
  var widget = root && root.querySelector('.jdgm-review-widget');
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function fmtDate(ds) {
    var m = (ds || '').match(/(\d{4})-(\d{2})-(\d{2})/);
    return m ? MONTHS[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] : '';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<span class="ps-rev__star' + (i <= n ? ' is-on' : '') + '">★</span>'; return s; }
  /* Review photos are re-hosted on our own Shopify CDN (owner rule 2026-07-17: never hotlink
     third-party servers). The Judge.me API still returns the imported ae-pic AliExpress URLs, so
     map each ae-pic filename to our CDN copy here; any UNKNOWN aliexpress URL is dropped, not leaked.
     Source of truth: media-src/review-photos/manifest.json. If Judge.me imports new photo reviews,
     re-host them and extend this map. */
  var PS_CDN_FILES = 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/';
  var PS_REHOST = {
    'A24850055887d4fe6b0f4de15b9a77dbah.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-robert-price-1.avif?v=1784429284',
    'A28dc295e829041e9b0da50415760a37ft.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-guadalupe-wintheiser-3.avif?v=1784429284',
    'A2c7cd1b6ddeb42e79e07f1f06efcee42R.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-alpha-schowalter-1.avif?v=1784429284',
    'A3577b4a9c7f2493586c0694c224f62afT.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-micheal-greenfelder-1.avif?v=1784429284',
    'A3cab71b8fdf447ca890201cd28d2adfdU.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-roberto-pacocha-1.avif?v=1784429284',
    'A3db75f80310b40f69c508cf4900bf1f6j.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-king-ratke-2.avif?v=1784429284',
    'A3e021c6a90f44b5a9ca22a6ea2b381f4z.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-reena-schulist-2.avif?v=1784429284',
    'A49a83b9b670046dd821eabc8d9823c4aG.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-reed-mcglynn-1.avif?v=1784429284',
    'A52ee7a1cbdde4fd0ba95b2c48fd99a05O.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-guadalupe-wintheiser-2.avif?v=1784429284',
    'A68cfd99732a94067adb8fcfbf3543a53F.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-ariel-turner-1.avif?v=1784429284',
    'A7effdeb34aa84ee48c07ec7ae8ab31e0W.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-guadalupe-wintheiser-1.avif?v=1784429284',
    'Aa76aff99fd7346db9473df8a66f7726ex.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-christian-moen-1.avif?v=1784429284',
    'Aac9175fbefbf45049223dd9a8b2ea834C.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-ayesha-torphy-1.avif?v=1784429284',
    'Ad49f9b818e1f49e2bf9f275f1639a88aq.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-junior-abshire-1.avif?v=1784429284',
    'Aeb8e9bc1c068417ebd4fc05cdc604b41k.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-scrub-king-ratke-1.avif?v=1784429284',
    'Aebfc83ed4135450f8b70b85dc680dbe2r.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-wall-micheal-greenfelder-2.avif?v=1784429284',
    'Af126ef5e9ea94e3b9728817f69d9360dY.jpg': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-diffuser-reena-schulist-1.avif?v=1784429284'
  };
  /* Review videos live on our own CDN (Judge.me free has no video field), keyed by the
     Judge.me review uuid returned by reviews_for_widget. Extend when new video reviews land. */
  var PS_REVIEW_VIDEOS = {
    '9943ec86-3993-47cd-b29b-19801ff5aea5': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-rocks-vid.mp4',
    'd2a90bdd-cd0e-41ae-ae48-34beb4899c6c': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-modern-vid.mp4',
    'f789159d-e742-485f-90fb-d7fd0781e25a': 'https://cdn.shopify.com/s/files/1/0670/2625/6078/files/review-bedside-vid.mp4'
  };
  /* Judge.me serves imported photos from TWO host spellings: review-images.judge.me and
     review-images.judgeme.com. This matched only the first for weeks while the API was
     actually returning the second, so 82 photos fell through to the old
     "if (u.indexOf('aliexpress') < 0) return u" line and were served straight from
     Judge.me's CDN (Errors item W). Match both, and never fail open again. */
  function rehost(u) {
    if (!u) return u;
    /* OWNER RULING 2026-09-08: "do not rehost them on shopify and let judge.me host it."
       This used to map Judge.me's slug back to our own copy on cdn.shopify.com, which is
       what the 2026-07-17 rule required. Judge.me is the reviews app we run, not a dropship
       host, and the leak that rule was written for (Errors W) was AliExpress and Temu URLs
       exposing where the goods come from. So Judge.me's own image hosts now pass through
       untouched, and the dropship drop below is unchanged. */
    if (/^https:\/\/review-images\.judge(\.me|me\.com)\//.test(u)) return u;
    // AliExpress-era imports carry no slug, so they go through the filename table.
    var m = /([A-Za-z0-9]+\.jpg)/.exec((u.split('?')[0].split('/').pop()) || '');
    if (m && PS_REHOST[m[1]]) return PS_REHOST[m[1]];
    /* STILL FAILS CLOSED for everything else. Judge.me and our own CDN are allowed above;
       anything we could not place is DROPPED rather than returned, because the URLs this
       catches are ae-pic AliExpress and kwcdn Temu, which announce the supplier. A photo that
       silently disappears is a visible bug; a photo that silently leaks is not. */
    return /^https:\/\/cdn\.shopify\.com\//.test(u) ? u : null;
  }
  function picThumb(p) { return rehost(!p ? null : (typeof p === 'string' ? p : (p.thumbnail || p.compact || p.original || p.huge || p.url))); }
  function picFull(p) { return rehost(!p ? null : (typeof p === 'string' ? p : (p.huge || p.original || p.compact || p.thumbnail || p.url))); }
  function picCount(r) { return (r.pictures_urls || []).length; }
  function byDateDesc(a, b) { return (b.created_at || '').localeCompare(a.created_at || ''); }

  /* ---- claims gate (CLAUDE.md claims matrix) ----
   * Republished UGC is a claim the store makes, so any review whose title/body asserts a
   * prohibited claim is dropped from the custom cards, for EVERY gated product. Ported from
   * assets/ps-home-reviews.js and extended with the task's terms (respiratory / anxiety /
   * blood pressure / EMF / therapeutic / heals). Anchored so it can't eat legitimate words:
   * no bare "therap" (keeps "Aromatherapy"), no bare "ion", and "heals\b" (not bare "heal")
   * so a reviewer named "Micheal" is never matched. Only title + body are tested here, never
   * the reviewer name. Measured on the live corpus it removes exactly the one "negative ions"
   * review and touches no criticism. */
  var BANNED_CLAIM = /negative ions?|ionis|ioniz|air[^.]{0,14}purif|purif[^.]{0,14}air|air quality|clean[^.]{0,10}the air|detox|toxins?|cellulite|acne|asthma|allerg|respiratory|anxiety|insomnia|migraine|blood ?pressure|\bemf\b|therapeutic|antibacterial|antimicrobial|cures?\b|heals\b|healing/i;
  function reviewText(r) {
    var d = document.createElement('div'); d.innerHTML = r.body_html || '';
    return ((r.title || '') + ' ' + (d.textContent || '')).replace(/\s+/g, ' ').trim();
  }
  function isClean(r) { return !BANNED_CLAIM.test(reviewText(r)); }

  /* ---- owner-pulled reviews, keyed by Judge.me review uuid ----
   * Hides the CARD only. Judge.me still holds the review, so the preview badge, the
   * "Based on N reviews" summary and the product's reviews.rating metafield (which feeds
   * collection cards and the AggregateRating structured data) all still count it. Hiding
   * it in the Judge.me admin as well is what makes those agree. Same client-side drop
   * pattern as the claims gate above. */
  var PS_REVIEW_HIDDEN = {
    // Modern lamp, Diana, 4 stars, "The brightness doesn't change, although the
    // description says it does." Owner removed 2026-08-10. Note the same complaint
    // survives in Lulu Loca's 5-star review (uuid 977665ba-...), which stays.
    '7a16e7ce-d071-4a4e-a4c2-227c6b058af7': 'modern-brightness-2026-08-10',
    // Original lamp, Lyubov, 5 stars, 2025-10-15. The text is fine; one of its three
    // photographs is a BRCOK branded box printed "Reduces allergic symptoms",
    // "Physically revitalizes", "Makes breathing easier". A rival's brand and three
    // medical claims, unreadable at 66px and legible at card width. 2026-09-10.
    '99e1a59d-de63-49c7-ae44-7bbb6cb681ad': 'natural-rival-box-banned-claims-2026-09-10',

    /* Modern lamp, seven reviews that PRAISE a dimmer this lamp does not have.
     * The owner confirmed on 2026-09-01, from the sample in his hand, that the lamp
     * has TWO modes on one button (press for steady amber, press for a colour cycle,
     * press for off) and NO brightness adjustment at all. The page itself was
     * corrected that day and has said 'there is no dimmer' since. These seven were
     * accepted as a known risk on 2026-08-13 and are pulled on 2026-09-11, because a
     * paid lander that answers 'is there a dimmer' with 'no' while seven reviews
     * underneath it describe 30 and 60 and 100 percent settings is not answering it.
     * Verified against the live Judge.me feed on 2026-09-11 before being listed here:
     * all seven uuids resolve, every reviewer name matches, and a broad sweep of all
     * 39 reviews found no eighth review making a brightness claim.
     * Card only. Judge.me still counts all seven, so the badge, the summary and the
     * reviews.rating metafield are unchanged until the owner hides them there too. */
    '7a57488b-c1b5-4027-bb6e-1950ba40692a': 'modern-dimmer-claim-2026-09-11',  // David K., "the lowest dim setting"
    'c68ad371-48a7-46d5-9835-f9654a0824ce': 'modern-dimmer-claim-2026-09-11',  // Chloe S., "u can dim it down for reading"
    '20fc98dc-2367-404c-8665-367c4806ca38': 'modern-dimmer-claim-2026-09-11',  // Robert H., "brightness levels"
    'db50f20a-e1b9-4377-85c2-851e687e145c': 'modern-dimmer-claim-2026-09-11',  // Jessica B., "the 30% brightness setting"
    'ff6dc0e5-28dc-431e-bb3f-ce335489d103': 'modern-dimmer-claim-2026-09-11',  // Lisa G., "the dimmability lets me set the exact mood"
    '7354df72-20a9-4264-89ac-9de019264d24': 'modern-dimmer-claim-2026-09-11',  // Rachel F., "at 100%, it puts out as much light as"
    'b8e0af8d-8190-44d4-8189-bf27f569d21f': 'modern-dimmer-claim-2026-09-11'   // Greg M., "varying brightness levels (30%, 60%, 100%)"
  };
  function isShown(r) { return !PS_REVIEW_HIDDEN[r.uuid]; }

  /* ---- buy-box preview badge: rewrite to "avg (N reviews)" (Judge.me re-asserts it, so we own our span) ---- */
  /* One rating format for the whole page, owner 2026-09-08: two decimals over 5.00, so
     the hero row, the buy-box badge and the band summary can never read three different
     numbers. The VALUE is always the real average; nothing here rounds it up. */
  function fmtRating(n) { return (n || 0).toFixed(1) + '/5.00'; }

  function enhanceBadge() {
    var pbs = document.querySelectorAll('.jdgm-preview-badge .jdgm-prev-badge');
    for (var i = 0; i < pbs.length; i++) {
      var pb = pbs[i], orig = pb.querySelector('.jdgm-prev-badge__text');
      var avg = pb.getAttribute('data-average-rating'), num = pb.getAttribute('data-number-of-reviews');
      if (!orig || !avg || !num) continue;
      var text = fmtRating(parseFloat(avg)) + ' (' + num + ' review' + (num === '1' ? '' : 's') + ')';
      var mine = pb.querySelector('.ps-badge-text');
      if (!mine) { mine = document.createElement('span'); mine.className = 'ps-badge-text'; orig.parentNode.insertBefore(mine, orig.nextSibling); }
      if (mine.textContent !== text) mine.textContent = text;
      orig.style.display = 'none';
    }
  }
  function enhanceSummary() { // "4.91 out of 5" -> big "4.9" (Judge.me may re-assert, so keep trimming)
    var a = document.querySelector('#ps-reviews .jdgm-rev-widg__summary-average');
    if (a && /out of/i.test(a.textContent)) { var n = parseFloat(a.textContent); if (!isNaN(n)) a.textContent = fmtRating(n); }
  }
  var badgeIv = setInterval(function () { if (document.querySelector('.jdgm-preview-badge .jdgm-prev-badge')) { enhanceBadge(); } enhanceSummary(); }, 400);
  setTimeout(function () { clearInterval(badgeIv); }, 20000);
  var bObs = document.querySelector('.ps-reviews-badge');
  if (bObs) new MutationObserver(enhanceBadge).observe(bObs, { childList: true, subtree: true });

  if (!widget) return;

  /* ---- custom review list from the Judge.me API (fetch all, sort + paginate client-side) ---- */
  var productId = widget.getAttribute('data-id');
  var shop = (window.Shopify && window.Shopify.shop) || location.hostname;
  var productTitle = (root.getAttribute('data-product-title') || '').trim();
  var apiBase = 'https://api.judge.me/reviews/reviews_for_widget?platform=shopify&url=' + shop + '&shop_domain=' + shop + '&product_id=' + productId;
  var PAGE_SIZE = 8;
  /* Sort is LATEST FIRST (owner 2026-09-08). It was briefly pictures-first, because the
     photographs were invisible on page one; that is now solved above the list instead, by
     the photo strip beside the rating, so the list can go back to reading chronologically. */
  var state = { all: [], shown: 0, photos: [], sort: 'most-recent', loaded: false };
  var listEl, moreBtn, sortSel;

  var COMPARATORS = {
    'most-recent': byDateDesc,
    'highest-rating': function (a, b) { return (b.rating || 0) - (a.rating || 0) || byDateDesc(a, b); },
    'lowest-rating': function (a, b) { return (a.rating || 0) - (b.rating || 0) || byDateDesc(a, b); },
    'pictures-first': function (a, b) { return picCount(b) - picCount(a) || byDateDesc(a, b); },
    'most-helpful': function (a, b) { return (b.thumb_up || 0) - (a.thumb_up || 0) || byDateDesc(a, b); }
  };

  /* Judge.me serves review photographs from its own host with a width parameter (the
     strict cdn.shopify.com rule was reversed for judge.me on 2026-09-08), so a card can
     ask for the size it actually paints instead of taking the 1024 the API hands back
     for every slot. Anything without that parameter is passed through untouched. */
  function picAt(u, w) {
    return u && /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u;
  }
  /* MEASURED on the rendered band, never guessed: SZ_ONE is a photo alone in a card,
     SZ_MANY is one of the two or three that share a card's row. */
  var SZ_ONE = '(min-width: 1160px) 313px, (min-width: 1050px) calc((100vw - 115px)/3 - 36px), '
    + '(min-width: 750px) calc(50vw - 84px), calc(100vw - 68px)';
  var SZ_MANY = '(min-width: 1160px) 100px, (min-width: 1050px) calc(((100vw - 115px)/3 - 49px)/3), '
    + '(min-width: 750px) calc((50vw - 97px)/3), calc((100vw - 81px)/3)';

  /* The card, drawn to the design the sample band previews (owner, 2026-09-10). The
     photographs are REAL <img loading="lazy">, not CSS backgrounds: a background on an
     element that is in the DOM downloads whether or not it is on screen, which is what
     put 137 KB of thumbnails on the wire at first paint before (Errors CT), and an img
     can carry alt text where a background never could. */
  function renderCard(r) {
    var rawName = (r.reviewer_name || r.reviewer_initial || 'Verified Buyer').trim();
    var name = esc(rawName);
    // the initial is taken BEFORE escaping: the first character of "&amp;" is "&"
    var initial = esc((rawName.charAt(0) || '?').toUpperCase());
    var date = fmtDate(r.created_at);
    var rating = r.rating || 5;
    var body = (r.body_html || '').trim();
    var bodyText = body.replace(/<[^>]+>/g, '').trim();
    if (bodyText && productTitle && bodyText === productTitle) body = ''; // hide placeholder body = product name
    /* Every review on this store is imported, so verified_buyer is false on all 298 of
       them and this chip renders nothing today. It exists so a genuinely verified review
       gets its badge, and so that nothing ever invents one (Errors CR). */
    var chip = r.verified_buyer ? '<span class="ps-rev__chip">Verified</span>' : '';
    var pics = (r.pictures_urls || []).map(function (p) {
      return { t: picThumb(p), f: picFull(p) };
    }).filter(function (x) { return x.t; }); // drop any photo we could not re-host (never leak AliExpress)
    var picsHtml = '';
    if (pics.length) {
      var one = pics.length === 1;
      // four across auto-fit columns is three and an orphan; 2x2 reads as a set
      var shape = one ? ' is-one' : (pics.length === 4 ? ' is-four' : '');
      picsHtml = '<div class="ps-rev__pics' + shape + '">' + pics.map(function (x) {
        var gi = state.photos.length;
        state.photos.push({ full: x.f || x.t, name: name, date: date, rating: rating, body: body });
        var base = x.f || x.t;
        return '<button type="button" class="ps-rev__pic" data-gi="' + gi
          + '" aria-label="Open a photo from ' + name + '\u2019s review"><img class="ps-rev__ph" src="'
          + picAt(base, one ? 640 : 320) + '" srcset="' + picAt(base, 320) + ' 320w, '
          + picAt(base, 480) + ' 480w, ' + picAt(base, 640) + ' 640w, '
          + picAt(base, 900) + ' 900w" sizes="'
          + (one ? SZ_ONE : SZ_MANY) + '" alt="Customer photo from a review by ' + name
          + '" loading="lazy" decoding="async"></button>';
      }).join('') + '</div>';
    }
    var vurl = PS_REVIEW_VIDEOS[r.uuid];
    var vidHtml = vurl ? '<div class="ps-rev__vid"><video controls preload="metadata" playsinline src="' + vurl + '"></video></div>' : '';
    return '<div class="ps-rev">'
      + '<div class="ps-rev__top">'
      + '<span class="ps-rev__av" aria-hidden="true">' + initial + '</span>'
      + '<span class="ps-rev__id"><b class="ps-rev__name">' + name + '</b>'
      + '<span class="ps-rev__meta">' + date + '</span></span>' + chip
      + '</div>'
      // the visible label is gone with the redesign, so the row carries its own
      + '<span class="ps-rev__stars" role="img" aria-label="Rated ' + rating + ' out of 5">'
      + stars(rating) + '</span>'
      + (body ? '<div class="ps-rev__body">' + body + '</div>' : '')
      + picsHtml
      + vidHtml
      + '</div>';
  }

  function rebuild() { // re-sort + re-render from the top (used on first load and on sort change)
    state.all.sort(COMPARATORS[state.sort] || byDateDesc);
    state.photos = [];
    fillPhotoStrip();   // strip claims indices 0..n-1, then the cards append after it
    state.shown = 0;
    listEl.innerHTML = '';
    appendMore();
  }
  function appendMore() {
    var slice = state.all.slice(state.shown, state.shown + PAGE_SIZE);
    listEl.insertAdjacentHTML('beforeend', slice.map(renderCard).join(''));
    state.shown += slice.length;
    if (moreBtn) moreBtn.style.display = state.shown >= state.all.length ? 'none' : 'block';
  }

  function fetchAll() { // one request to learn total_pages, then the rest in parallel
    return fetch(apiBase + '&per_page=30&page=1')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.pagination || !Array.isArray(j.reviews)) throw new Error('unexpected response');
        state.total = j.number_of_reviews || 0;
        state.avg = parseFloat(j.average_rating) || 0;
        var total = j.pagination.total_pages || 1;
        var acc = j.reviews.slice(), rest = [];
        for (var p = 2; p <= total; p++) {
          rest.push(fetch(apiBase + '&per_page=30&page=' + p)
            .then(function (r) { return r.json(); })
            .then(function (jj) { return (jj && jj.reviews) || []; })
            .catch(function () { return []; }));
        }
        return Promise.all(rest).then(function (pages) { pages.forEach(function (arr) { acc = acc.concat(arr); }); return acc; });
      });
  }

  function fallbackToNative() { root.classList.add('ps-rev-fallback'); } // API down -> show Judge.me's own cards + native sort

  /* Judge.me's cached widget does not always carry a summary block: on the Original
     lamp it ships 593 bytes with no .jdgm-rev-widg__summary at all, so the band had a
     heading, an intro and then review cards with no rating anywhere above them. We
     already hold the real average and count from the API response, so render them. */
  /* The top row: rating on the left, customer photographs on the right (owner
     2026-09-08, "i want the pictures to be shwon on the top on right side of the
     rating"). The photographs are the strongest thing on this band and they used to
     be unreachable: on this product the reviews that carry them are months older
     than the bulk import, so at eight cards a page nobody ever saw one. Lifting a
     strip of them out of the list means the list itself can stay newest-first. */
  function buildTopRow() {
    if (!listEl || root.querySelector('.ps-revtop')) return null;
    var row = document.createElement('div');
    row.className = 'ps-revtop';
    row.innerHTML = '<div class="ps-revtop__l"></div><div class="ps-revphotos"></div>';
    // the sort control sits just above the list when Judge.me gives us no summary to
    // hang it in, so the top row goes ABOVE the sort, not between it and the list
    var before = (sortSel && sortSel.parentNode === listEl.parentNode) ? sortSel : listEl;
    before.parentNode.insertBefore(row, before);
    row.querySelector('.ps-revphotos').addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.ps-rev__pic');
      if (b) show(+b.getAttribute('data-gi'));
    });
    return row;
  }

  function buildOwnSummary() {
    var cell = root.querySelector('.ps-revtop__l');
    if (!cell || widget.querySelector('.jdgm-rev-widg__summary') || cell.firstChild) return;
    if (!state.total) return;
    var el = document.createElement('div');
    el.className = 'ps-revsum';
    el.innerHTML = '<span class="ps-revsum__avg">' + fmtRating(state.avg) + '</span>'
      + '<span class="ps-revsum__stars">' + stars(Math.round(state.avg)) + '</span>'
      + '<span class="ps-revsum__count">Based on ' + state.total + ' review'
      + (state.total === 1 ? '' : 's') + '</span>';
    cell.appendChild(el);
  }

  /* Filled from the photo-bearing reviews regardless of how the LIST is sorted, and
     re-filled on every rebuild because rebuild() resets state.photos, which is what
     the lightbox indexes into. Strip first, cards after, so the indices stay valid. */
  /* The hero row is server rendered from the judgeme.badge metafield, which lags the
     API by a few minutes after an import. Once the real numbers are in hand, reconcile
     it, so the hero, the buy-box badge and the band summary never disagree. */
  function syncHeroRate() {
    var hr = document.querySelector('.ps-nhero__rate');
    if (!hr || !state.total) return;
    var b = hr.querySelector('b'), c = hr.querySelector('span:last-child');
    if (b) b.textContent = fmtRating(state.avg);
    if (c) c.textContent = 'from ' + state.total + ' reviews';
  }

  /* Delivery is not the argument the first screen should be having (owner, 2026-09-10:
     "exclude quotes mentioning delivery in hero section"). Both directions go, not just
     the complaints: one qualifying review opened "It took quite a while to arrive", and
     two others praised the speed, which reads as a delivery promise this store does not
     make (12 to 15 days). Measured against the live corpus the day it was written: 35
     reviews qualified, 5 spoke about the shipment, 30 remain, so the pool is not thin.
     The band itself still shows all of them: this filter is the HERO only. */
  var HERO_NO_DELIVERY = /\b(deliver\w*|ship\w*|arriv\w*|courier\w*|postage|posted|parcel\w*|packag\w*|transit|tracking|dispatch\w*|customs|await\w*|wait\w*|late|delay\w*|slow\w*|quick\w*|fast\w*|prompt\w*|speedy|on time)\b/i;

  /* One real review on the first screen, owner 2026-09-08. Picked at random from the
     five-star reviews SHORT enough to sit on one line, so nothing is ever truncated:
     a clipped review is a rewritten review. Empty in the HTML and filled here, so the
     template holds no review copy that could go stale or read as ours. */
  function fillHeroQuote() {
    var el = document.querySelector('[data-ps-hero-quote]');
    if (!el || el.firstChild) return;
    var pool = state.all.filter(function (r) {
      var t = (r.body_html || '').replace(/<[^>]+>/g, '').trim();
      return r.rating === 5 && t.length >= 24 && t.length <= 86
        && !HERO_NO_DELIVERY.test(t) && (r.reviewer_name || '').trim();
    });
    if (!pool.length) return;
    var r = pool[Math.floor(Math.random() * pool.length)];
    var t = (r.body_html || '').replace(/<[^>]+>/g, '').trim();
    el.innerHTML = '“' + esc(t) + '” <b>' + esc(r.reviewer_name.trim()) + '</b>';
  }

  var STRIP_MAX = 10;
  function fillPhotoStrip() {
    var host = root.querySelector('.ps-revphotos');
    if (!host) return;
    host.innerHTML = '';
    var withPics = state.all.filter(picCount).sort(byDateDesc);
    var made = 0, html = '';
    for (var i = 0; i < withPics.length && made < STRIP_MAX; i++) {
      var r = withPics[i], ps = r.pictures_urls || [];
      for (var j = 0; j < ps.length && made < STRIP_MAX; j++) {
        var t = picThumb(ps[j]);
        if (!t) continue;
        var gi = state.photos.length;
        state.photos.push({ full: picFull(ps[j]) || t, name: esc(r.reviewer_name || ''),
                            date: fmtDate(r.created_at), rating: r.rating || 5,
                            body: (r.body_html || '').trim() });
        // A REAL <img loading="lazy">, not a CSS background. A background on an
        // element that exists in the DOM is fetched whether or not it is on screen,
        // and this strip sits about 4,000px down a phone: it was pulling ten
        // cross-origin thumbnails, roughly 137 KB, at first paint. It hid from every
        // byte count because review-images.judgeme.com sends no Timing-Allow-Origin,
        // so each one reports encodedBodySize 0. Errors CT. The img also earns the
        // thumbnails alt text, which a background could never have.
        html += '<button type="button" class="ps-rev__pic ps-revphotos__i" data-gi="' + gi
             + '" aria-label="Open a customer photo"><img src="' + t
             + '" alt="" loading="lazy" decoding="async" width="72" height="72"></button>';
        made++;
      }
    }
    host.innerHTML = html;
    host.style.display = made ? '' : 'none';
  }

  function buildSort() {
    var wrap = document.createElement('label');
    wrap.className = 'ps-sort';
    wrap.innerHTML = '<span class="ps-sort__lbl">Sort</span>';
    var sel = document.createElement('select');
    sel.className = 'ps-sort__sel';
    sel.setAttribute('aria-label', 'Sort reviews');
    var opts = [['most-recent', 'Most Recent'], ['highest-rating', 'Highest Rating'], ['lowest-rating', 'Lowest Rating'], ['pictures-first', 'Pictures First'], ['most-helpful', 'Most Helpful']];
    sel.innerHTML = opts.map(function (o) { return '<option value="' + o[0] + '">' + o[1] + '</option>'; }).join('');
    sel.value = state.sort;
    sel.addEventListener('change', function () { state.sort = sel.value; rebuild(); });
    wrap.appendChild(sel);
    return wrap;
  }

  /* ---- lightbox ---- */
  var lb, lbImg, lbCap, lbIndex = 0;
  function buildLightbox() {
    lb = document.createElement('div');
    lb.className = 'ps-lb';
    lb.innerHTML = '<div class="ps-lb__backdrop"></div>'
      + '<div class="ps-lb__stage"><button class="ps-lb__nav ps-lb__prev" aria-label="Previous">‹</button>'
      + '<img class="ps-lb__img" alt="Review photo"><button class="ps-lb__nav ps-lb__next" aria-label="Next">›</button></div>'
      + '<div class="ps-lb__cap"></div><button class="ps-lb__close" aria-label="Close">×</button>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.ps-lb__img'); lbCap = lb.querySelector('.ps-lb__cap');
    function close() { lb.classList.remove('is-open'); }
    lb.querySelector('.ps-lb__close').addEventListener('click', close);
    lb.querySelector('.ps-lb__backdrop').addEventListener('click', close);
    lb.querySelector('.ps-lb__prev').addEventListener('click', function () { show(lbIndex - 1); });
    lb.querySelector('.ps-lb__next').addEventListener('click', function () { show(lbIndex + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(lbIndex - 1); else if (e.key === 'ArrowRight') show(lbIndex + 1);
    });
  }
  function show(i) {
    var n = state.photos.length; if (!n) return;
    lbIndex = (i + n) % n;
    var ph = state.photos[lbIndex];
    lbImg.src = ph.full;
    lbCap.innerHTML = '<span class="ps-lb__name">' + esc(ph.name) + '</span> <span class="ps-lb__date">' + ph.date + '</span> <span class="ps-lb__stars">' + stars(ph.rating) + '</span>' + (ph.body ? '<div class="ps-lb__body">' + ph.body + '</div>' : '');
    lb.classList.add('is-open');
  }

  function init() {
    if (!lb) buildLightbox();

    // our brand sort control, stacked under the summary (average + "Based on N reviews")
    var summary = widget.querySelector('.jdgm-rev-widg__summary');
    sortSel = buildSort();
    if (summary) summary.appendChild(sortSel);

    // list + load more as BLOCK siblings after the whole header (not inside the flex summary row)
    var anchor = widget.querySelector('.jdgm-rev-widg__header') || summary || widget.firstElementChild || widget;
    listEl = document.createElement('div'); listEl.className = 'ps-rev-list';
    moreBtn = document.createElement('button'); moreBtn.type = 'button'; moreBtn.className = 'ps-loadmore'; moreBtn.textContent = 'Load more reviews';
    moreBtn.style.display = 'none';
    moreBtn.addEventListener('click', appendMore);
    listEl.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.ps-rev__pic');
      if (b) show(+b.getAttribute('data-gi'));
    });
    anchor.parentNode.insertBefore(listEl, anchor.nextSibling);
    if (!summary) listEl.parentNode.insertBefore(sortSel, listEl); // no summary: put sort just above the list
    listEl.parentNode.insertBefore(moreBtn, listEl.nextSibling);

    fetchAll()
      .then(function (all) {
        state.loaded = true;
        if (!all.length) { fallbackToNative(); return; } // API returned nothing -> show Judge.me's own cards
        state.all = all.filter(isClean).filter(isShown); // claims gate, then owner-pulled reviews
        if (!state.all.length) return; // everything filtered out: leave the list empty rather than resurface banned cards via the native fallback
        buildTopRow();
        buildOwnSummary();
        syncHeroRate();
        fillHeroQuote();
        rebuild();
      })
      .catch(function () { fallbackToNative(); });
  }

  /* This used to wait 80 x 250ms for one of Judge.me's own elements before doing
     anything, and only then init anyway. On a product whose cached widget carries
     none of them, that is a REVIEW BAND THAT IS BLANK FOR TWENTY SECONDS, which on a
     paid lander is the same as no reviews at all (measured on the Original lamp,
     2026-09-08: 0 cards at 7s, 8 cards at 26s).

     So: give Judge.me two seconds, then build regardless. The only thing its summary
     was needed for is where the sort control sits, and that is now handled after the
     fact: if the summary turns up late, the control moves into it, which keeps the
     six PDPs where Judge.me does render a summary looking exactly as they did. */
  var tries = 0, iv = setInterval(function () {
    if (widget.querySelector('.jdgm-rev-widg__summary') || widget.querySelector('.jdgm-rev') || widget.querySelector('.jdgm-histogram')) { clearInterval(iv); init(); }
    if (++tries > 8) { clearInterval(iv); if (!listEl) init(); }
  }, 250);

  var late = 0, lateIv = setInterval(function () {
    var sum = widget.querySelector('.jdgm-rev-widg__summary');
    if (sum && sortSel && sortSel.parentNode !== sum) {
      sum.appendChild(sortSel);
      var own = root.querySelector('.ps-revtop__l .ps-revsum');
      if (own && own.parentNode) own.parentNode.removeChild(own); // Judge.me's summary wins
    }
    if (sum || ++late > 80) clearInterval(lateIv);
  }, 250);
})();
